var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.Career.Messages.Submit, Vendd.Career, function (envelope) {
        var options = {
            url: 'JobApplicationService.svc/SubmitCv',
            data:
            {
                info: envelope.message.data
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            if (response.success) {
                Vendd.MessageBus.publishAsync(Vendd.Career, new Vendd.Career.Messages.SubmitSuccess(response));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Career, new Vendd.Career.Messages.SubmitFailure(response));
            }
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Career, new Vendd.Career.Messages.SubmitFailure(response));
        };

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});